import React from 'react';
import Modal from 'jd-library/Modal';
import styles from './style.scss';
import DotLoader from '../../atoms/DotLoader';
import { useSelector } from 'react-redux';
import Image from '../../atoms/Image';

const ReviewModal = props => {
    const profileObject = useSelector(state => state.session.profileObject);
    // let productServiceTxt = newProfile == 3 ? 'Services' : newProfile == 2 ? 'Products/Services': 'Products';
    return (
        <Modal
            settings={{
                modalId: 'review-redirect'
            }}
            onHidden={props.onHidden}
        >
            <Modal.Body className={styles['modal-bdy']}>
                <div className={styles['review-redirect']}>
                    <Image Src={"https://image1.jdomni.in/jdomni_email/VectorsApproved_2308011850.jpg"} />
                    <div className={styles['heading-txt']}>{`${profileObject?.PluralLabelWithSpace} Approved Successfully`}</div>
                    <div className={styles['content']}>
                        Redirecting to Customer Feedback
                    </div>
                    <DotLoader />
                </div>
            </Modal.Body>
        </Modal>
    )
};

export default ReviewModal;